module.exports = __webpack_public_path__ + "static/img/hat.a659f5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hat.png
// module id = XUdT
// module chunks = 0